import Route from '@ember/routing/route';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import JournalTemplateModel from 'donor-elf-web/models/journal-template';
import JournalService from 'donor-elf-web/services/journal-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import JournalInfo from 'donor-elf-web/lib/models/journal-info';

export interface JournalAddRouteModel {
  templates: JournalTemplateModel[];
  duplicateJournalInfo?: JournalInfo;
}

export default class JournalAddRoute extends Route {
  @service declare journalService: JournalService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  queryParams = {
    duplicateJournalId: {},
  };

  beforeModel() {
    this.navbarSettings.title = 'Add Journal';
  }

  async model(params: {
    duplicateJournalId?: string;
  }): Promise<JournalAddRouteModel> {
    await this.journalService.load();
    let duplicateJournalInfo: JournalInfo | undefined;
    let templates: JournalTemplateModel[] = [];
    if (params.duplicateJournalId) {
      duplicateJournalInfo = this.journalService.journalInfoById(
        params.duplicateJournalId,
      );
      this.navbarSettings.title = 'Duplicate Journal';
    } else {
      templates = (await this.store.query('journal-template', {})).slice();
    }
    return {
      templates,
      duplicateJournalInfo,
    };
  }
}
